import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';

export class InspectionReportHistory implements ViewModel {
  friendlyTypeNameSingular: string = 'Inspection Report History';
  apiRoute = CONFIG.apiRoutes.inspectionReportHistory;

  description: string;
  discriminator: string;
  inspectionDate: Date;
  inspectionConfidence: string;

  constructor() {}

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.description = data.description;
    this.discriminator = data.discriminator;
    this.inspectionDate = data.inspectionDate;
    this.inspectionConfidence = data.inspectionConfidence;
  }
}
